import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsDatepickerModule } from '@lcs/shared/datepicker';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CallCostsDialogModule } from 'src/app/common-components/call-costs-dialog/call-costs-dialog.module';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { FileUploadModule } from 'src/app/common-components/file-upload/file-upload.module';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { AddProviderCallCostComponent } from './containers/add-provider-call-costs.component';
import { AddProviderCallCostEffects } from './state/add-provider-call-costs.effects';
import * as fromAddProviderCallCost from './state/add-provider-call-costs.reducer';
import { AddProviderCallCostViewComponent } from './views/add-provider-call-costs-view.component';
@NgModule({
   declarations: [AddProviderCallCostComponent, AddProviderCallCostViewComponent],
   imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      MatInputModule,
      MatRadioModule,
      FileUploadModule,
      MatButtonModule,
      AddSpacesPipeModule,
      MatTooltipModule,
      MatSelectModule,
      MatDialogModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      MatIconModule,
      MatCardModule,
      EntitySelectModule,
      LcsDatepickerModule,
      CallCostsDialogModule,
      StoreModule.forFeature(fromAddProviderCallCost.addProviderCallCostFeatureKey, fromAddProviderCallCost.reducer),
      EffectsModule.forFeature([AddProviderCallCostEffects]),
   ],
})
export class AddProviderCallCostModule {}
